<template>
  <div class="flex flex-row items-center py-1 pl-[11px] pr-0 gap-3 self-stretch">
    <div class="flex items-center justify-center w-6 h-6 rounded-md shrink-0">
      <i
        class="pi pi-user text-[#325F80]"
        style="font-size: 1.25rem;"
      />
    </div>
    <div class="flex flex-col gap-0.5 flex-1 min-w-0">
      <span class="font-bold text-base leading-[19px] text-[#2d3032] overflow-hidden text-ellipsis whitespace-nowrap">{{ fullName || $t('settings.profile') }}</span>
      <span class="font-normal text-sm leading-[17px] text-[#717379] overflow-hidden text-ellipsis whitespace-nowrap">{{ company || roleLabel }}</span>
    </div>
    <button
      v-if="isMobile"
      v-tooltip.bottom="$t('profile.edit_your_profile')"
      type="button"
      class="inline-flex items-center justify-center w-8 h-8 rounded-full border-none bg-transparent text-[#2b3035] cursor-pointer transition-colors duration-150 hover:bg-[#f2f5f8] focus-visible:bg-[#f2f5f8] focus-visible:outline-none shrink-0"
      :aria-label="$t('profile.edit_your_profile')"
      @click="$emit('edit')"
    >
      <i
        class="pi pi-user-edit text-[#325F80]"
        style="font-size: 1.125rem;"
      />
    </button>
    <button
      v-if="isMobile"
      type="button"
      class="inline-flex items-center justify-center w-8 h-8 rounded-md border-none bg-[#F2F5F8] text-[#2b3035] cursor-pointer transition-colors duration-150 hover:bg-[#f2f5f8] focus-visible:bg-[#f2f5f8] focus-visible:outline-none ml-auto shrink-0"
      :aria-label="$t('common.back')"
      @click="$emit('close')"
    >
      <i
        class="pi pi-times text-[#325F80]"
        style="font-size: 1.125rem;"
      />
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Tooltip from 'primevue/tooltip';

export default defineComponent({
  name: 'ProfileMenuHeader',
  directives: {
    tooltip: Tooltip,
  },
  props: {
    fullName: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    roleLabel: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['edit', 'close'],
});
</script>
